import type { Rotina } from "~/types/pagesMenu";

const nomesRotinasConsulta = {
	UMA: "U.M.A.",
	ENDERECO: "Endereço",
	MERCADORIA: "Mercadoria",
	PALETE: "Palete",
} as const;

export type RotinasConsulta = typeof nomesRotinasConsulta[keyof typeof nomesRotinasConsulta];

/**
 * Consultas avulsas — o "B4 - Consultas" do `SIST_MAINFORM`.
 *
 * São as consultas que o operador dispara a qualquer momento, sem estar dentro
 * de uma rotina. No Delphi elas vivem num submenu próprio; aqui ficam atrás do
 * botão de lupa do topo (`AppTopbar.vue`) — fora da grade, justamente porque não
 * são etapa de operação como as demais categorias.
 *
 * A categoria "Consulta" continua existindo em `useSetMenusCollector`: é ela que
 * aplica a permissão. O que mudou foi só onde a lista é desenhada — a grade a
 * ignora (`collectorOptions.vue`) e o topbar a lê (`useConsultasLiberadas`).
 *
 * ## Sobre o `nome`
 *
 * O menu só mostra o item quando `ACEUSU_ID_MENU_PF` do usuário contém este
 * valor. O identificador do submenu em si — `mni_ColetorDadosConsultas` —
 * **não** serve: ele existe nas bases, mas quase ninguém o tem (1 usuário na
 * EPOCA, 15 na AGALDINO), porque a permissão que os operadores realmente
 * recebem é a da consulta em si.
 *
 * Por isso todas usam `mni_ConsultaMercadoriaRuaUMA` — o "B41 - Consulta
 * Mercadoria / Rua / U.M.A", que no Delphi abre
 * `PROC_CONSULTA_SALDO_ESTOQUE_COLETOR` e é a permissão de consulta do coletor
 * de fato distribuída: 579 usuários na EPOCA. É o que faz a seção aparecer para
 * quem hoje já consulta.
 */
const rotinasConsulta: Rotina[] = [
	{
		categoria: "Consulta",
		label: nomesRotinasConsulta.UMA,
		nome: "mni_ConsultaMercadoriaRuaUMA",
		rotina: "consulta/UMA",
		tela: "PROC_CONSULTA_SALDO_ESTOQUE_COLETOR",
		disponivel: true,
	},
	{
		categoria: "Consulta",
		label: nomesRotinasConsulta.ENDERECO,
		nome: "mni_ConsultaMercadoriaRuaUMA",
		rotina: "consulta/endereco",
		tela: "PROC_CONSULTA_ENDERECO",
		disponivel: true,
	},
	{
		categoria: "Consulta",
		label: nomesRotinasConsulta.MERCADORIA,
		nome: "mni_ConsultaMercadoriaRuaUMA",
		rotina: "PROC_CONS_MERC_COLETOR",
		tela: "PROC_CONS_MERC_COLETOR",
		disponivel: true,
	},
	{
		/*
		 * A tela está em `pages/PROC_PALETES_LOCALIZACAO_DOCA/PROC_PALETES_LOCALIZACAO_DOCA.vue`,
		 * mas o hook `pages:extend` do `nuxt.config` colapsa pasta e arquivo de
		 * mesmo nome numa rota só — daí o caminho não vir duplicado.
		 */
		categoria: "Consulta",
		label: nomesRotinasConsulta.PALETE,
		nome: "mni_ConsultaMercadoriaRuaUMA",
		rotina: "PROC_PALETES_LOCALIZACAO_DOCA",
		tela: "PROC_PALETES_LOCALIZACAO_DOCA",
		disponivel: true,
	},
];

export { rotinasConsulta };
export default rotinasConsulta;
